import axios from '../index';

export const requestSendEmailDoctorNotification = ({ patientId, doctorId }) =>
  axios.post(`/notification/transmission-report/${patientId}/${doctorId}`);

export const requestSendReviewReport = ({ patientId, observationId }) =>
  axios.post(`/notification/review-report/${patientId}/${observationId}`);
